import axios from 'axios';

const root = process.env.API_ROOT

// baseURL.baseHost
//axios配置
axios.defaults.timeout = 10000
// axios.defaults.baseURL="http://172.30.112.101:8080/health/";
axios.defaults.headers.post['Content-Type'] =
  'application/json';
// POST传参序列化
axios.interceptors.request.use(
  config => {
    // config.headers={'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'}
    if (config.method === 'post') {

      // config.data = qs.stringify(config.data);
      //  config.headers.post["Content-Type"]='application/json';
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//返回状态判断
axios.interceptors.response.use(
  res => {
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(root + url, JSON.stringify(params))
      .then(
        response => {
          resolve(response.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })

  })
}

export function post2(url, params,token) {
  return new Promise((resolve, reject) => {
    axios
      .post(root + url, JSON.stringify(params),{headers:{accessToken:token}})
      .then(
        response => {
          resolve(response.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })

  })
}

export function fetch (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(root + url, {
        params: params
      })
      .then(
        response => {
          resolve(response.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })

  })
}

export function fetch2 (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(root + url, {
        headers: {
          accessToken: params
        }
      })
      .then(
        response => {
          resolve(response.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })

  })
}
export default {

  /*  单项检查 */
  // 获取单项检查的项目分类
  getItemCat () {
    return fetch('api/getItemCat')
  },
  // 根据项目分类获取项目
  getSingleCheck (categoryID) {
    return fetch('api/getSingleCheck/' + categoryID)
  },

  /*  固定套餐 */
  // 获取套餐分类接口
  getComboCat () {
    return fetch('api/getComboCat')
  },
  // 根据套餐分类获取该分类下的套餐信息
  getComboInfo (comboCategoryID) {
    return fetch('api/getComboInfo/' + comboCategoryID)
  },

  /*  对指定套餐或者1+X套餐（加入购物车、待付款、付款）操作
   params:
   COMBO_ID (套餐ID)
   addItemId[] (新增项目ID集合)
   STATUS(状态：1加入购物车5待付款10已付款待预约)
   PRICE(订单总结)
   TYPE (类别：1 "1+X"套餐、2 固定套餐、3 单项检查、4 团检套餐) */
  weixinOrder (tjrID, userID, params) {
    return post('api/weixinOrder/' + tjrID + '/' + userID, params)
  },

  // 个人预约
  /* 根据订单号，进行预约
  params:
  PRESET_TIME (预约时间段) */
  order (orderNO, params) {
    return post('api/order/' + orderNO, params)
  },

  // 购物车转付款（或者待付款）
  // 将购物车里面的订单变成付款状态或者待付款状态
  /* 将待付款状态变成付款状态
  params:
  orderIds[] (订单ID集合)
  STATUS (订单将要执行的状态：1加入购物车 5 待付款 10 付款) */
  changeOrderStatus (userID, params) {
    return post('api/changeOrderStatus/' + userID, params)
  },

  // 查询我的订单
  searchOrder (userID) {
    return fetch('api/searchOrder/' + userID)
  },

  // 个人信息
  // 查看个人信息
  getCustomerInfo (tjrID, userID, token) {
    console.log(token)
    return fetch2('api/user/getCustomerInfo/' + tjrID + '/' + userID, token)
  },

  // 根据套餐id获取套餐详情 以及项目分类
  getDetails (comboID) {
    return fetch('api/getDetails/' + comboID)
  },

  // 团检预约
  teamOrder (userID, params) {
    return post('api/teamOrder/' + userID, params)
  },

  // 登录 绑定当前用户信息
  getVerifyingCode (params) {
    return post('api/getVerifyingCode', params)
  },

  // 注册 获取验证码
  getRegCode (params) {
    return post('api/getRegCode', params)
  },

  // 注册或登记
  /*  params:
   PHONE_NUM:手机号
   GENDER: 性别：0女1男
   CARD_TYPE:  证件类型：1身份证5护照
   EDUCATION://文化程度0小学5初中10高中15专科20学士25硕士30博士35博士后40其他
   EMAIL:  邮箱
   JOB : 职业
   BIRTHDAY : 出生日期
   ID_CARD:  身份证
   NAME: 姓名 */
  registered (params) {
    return post('api/registered', params)
  },
  // 添加体检人
  addUser (userID, params,token) {
    return post2('api/user/addUser/' + userID, params,token)
  },

  // 获取基础代码项（性别、证件类型、文化程度、职业、关系类型）
  getBasicData () {
    return fetch2('api/getBasicData')
  },

  // 获取token接口
  getToken (idCard, verCode) {
    return fetch('api/getToken2/' + idCard + '/' + verCode)
  },

  // 查看购物车
  goShoppingCart (userID) {
    return fetch('api/queryMyOrder/goShoppingCart/' + userID)
  },
  // 查看待付款状态
  goUnpay (userID) {
    return fetch('api/queryMyOrder/goUnpay/' + userID)
  },
  // 查看待预约状态
  goUnOrder (userID) {
    return fetch('api/queryMyOrder/goUnOrder/' + userID)
  },
  // 查看待体检状态
  goOrder (userID) {
    return fetch('api/queryMyOrder/goOrder/' + userID)
  },
  // 查看已体检状态
  goStart (userID) {
    return fetch('api/queryMyOrder/goStart/' + userID)
  },
  // 查看已完成状态
  goFinish (userID) {
    return fetch('api/queryMyOrder/goFinish/' + userID)
  },
  // 查看和自己相关的体检人信息、选择体检人只做套餐
  queryUser (userID, token) {
    return fetch2('api/user/queryUser/' + userID, token)
  },
  // 根据体检记录ID获取基础项目和新增项目
  queryMyOrderItems (orderID) {
    return fetch('api/queryMyOrderItems/' + orderID)
  },

  // 删除订单接口（购物车和待付款）
  deleteOrder (orderID, userID) {
    return post('api/deleteOrder/' + orderID + '/' + userID)
  },
  // 修改个人信息
  updateCurrentUser (userID, params,token) {
    return post2('api/user/updateCurrentUser/' + userID, params,token)
  },
  // 预约获取可预约时间段
  findIntervalByDate (date) {
    return fetch('api/findIntervalByDate/' + date)
  },
  // 根据订单号进行预约
  order (orderID, params) {
    return post('api/order/' + orderID, params)
  },
  // 取消预约接口
  cancelOrder (orderID) {
    return post('api/cancelOrder/' + orderID)
  },

  // 团检加项
  addGroupItem (orderID, userID, params) {
    return post('api/addGroupItem/' + orderID + '/' + userID, params)
  },
  // 微信支付
  pay (money, state, currentId,url) {
    return fetch('api/pay?money=' + money + '&state=' + state + '&currentId=' + currentId + '&url=' + url)
  },
  // 查询微信订单情况
  payQuery (state) {
    return fetch('api/payQuery?state=' + state)
  },
  // 修改体检人信息
  updateUser (tjrID, userID, params,token) {
    return post2('api/user/updateUser/' + tjrID + '/' + userID, params,token)
  },
  // 删除体检人信息
  deleteUser (tjrID, userID,token) {
    return fetch2('api/user/deleteUser/' + tjrID + '/' + userID,token)
  },

  // 获得签名
  gettAccseeToken (params) {
    return post('api/wx/jsapi', params)
  },

  // 查询下一站去哪里
  getNextStation (params) {
    return post('api/wx/getNextStation', params)
  }

}



// WEBPACK FOOTER //
// ./src/fetch/api.js